import loadable from '@loadable/component';

export const DashboardPage = loadable(/* #__LOADABLE__ */ () => import('./DashboardPage'));
